import React, { useEffect, useState } from "react";
import { Users2, ClipboardList } from "lucide-react";
import { api } from "@/lib/api";

export default function VolunteerDirectory() {
  const [groups, setGroups] = useState([]);
  useEffect(() => { api.get("/volunteers/directory").then(({ data }) => setGroups(data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="volunteer-directory">
      <div>
        <span className="hf-eyebrow">The team</span>
        <h1 className="mt-1 font-heading text-3xl font-semibold text-[#00334a]">Volunteer Directory</h1>
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        {groups.map((g) => (
          <div key={g.role} className="rounded-2xl border border-[#e4d8c4] bg-white p-5" data-testid={`directory-group-${g.role}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 font-heading text-lg font-semibold text-[#00334a]">
                <Users2 className="h-5 w-5 text-[#65949c]" /> {g.label}
              </div>
              <span className="rounded-full bg-[#efe6d6] px-2.5 py-0.5 text-xs font-bold text-[#3f6670]">{g.count}</span>
            </div>
            <div className="mt-3 space-y-2">
              {g.volunteers.length === 0 && <div className="text-sm text-[#7c7a6a]">No volunteers in this role yet.</div>}
              {g.volunteers.map((v) => (
                <div key={v.id} className="flex items-center justify-between rounded-xl bg-[#f8f3e9] px-3 py-2 text-sm">
                  <div>
                    <span className="font-semibold text-[#00334a]">{v.name}</span>
                    {v.is_active === false && <span className="ml-2 rounded-full bg-[#f3e7db] px-1.5 py-0.5 text-[10px] font-bold uppercase text-[#b05e3c]">Inactive</span>}
                    <div className="text-xs text-[#7c7a6a]">{v.email}</div>
                  </div>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#3f6670]"><ClipboardList className="h-3.5 w-3.5" /> {v.open_tasks} open</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
